/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Ref_MissingInputs */

const vi_error_shop_ref_missing = /** @type {(inputs: Error_Shop_Ref_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục, nhóm hoặc SKU vừa chọn không còn tồn tại. Tải lại trang rồi thử lại.`)
};

/**

* @param {Error_Shop_Ref_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_ref_missing = /** @type {((inputs?: Error_Shop_Ref_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Ref_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_ref_missing(inputs)
});